import type { FormFieldProps } from '@nzyme/vue-forms/components/defineFormField.js';
import type { ExtractPropTypes, PropType } from 'vue';

import css from './ButtonInput.module.scss';

export type ButtonInputSize = 'medium' | 'small';
export type ButtonInputProps = ExtractPropTypes<typeof ButtonInputProps>;
export const ButtonInputProps = {
    size: {
        type: String as PropType<ButtonInputSize>,
        default: 'medium',
    },
};

export function getButtonInputClass<T>(props: ButtonInputProps & FormFieldProps<T>, selected?: boolean) {
    return [
        css.button,
        props.size && css[`size_${props.size}`],
        props.disabled && css.disabled,
        props.readonly && css.readonly,
        selected && css.selected,
    ];
}
